import lng from '@lightningjs/core';
import { Colors, Utils } from '@lightningjs/sdk';
import { Column } from '@lightningjs/ui-components';

export default class Filters extends lng.Component {
  static _template() {
    return {
      w: 1920,
      h: 1080,
      plinko: true,
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: lng.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      FiltersLogo: {
        x: 240,
        y: 460,
        texture: lng.Tools.getSvgTexture(
          Utils.asset('/images/settings-icons/filters.svg'),
          115,
          115
        ),
      },
      FiltersTitle: {
        x: 100,
        y: 570,
        w: 394,
        text: {
          text: 'Filters',
          textColor: Colors('#fafafa').get(),
          textAlign: 'center',
          fontSize: 40,
        },
      },
      FilterContent: {
        x: 800,
        y: 330,
        fontSize: 40,
        Column: {
          collision: true,
          type: Column,
        },
      },
    };
  }

  get _FilterContent() {
    return this.tag('FilterContent.Column');
  }

  $setIndex(index) {
    this._FilterContent.selectedIndex = index;
  }

  _getFocused() {
    return this._FilterContent;
  }
}
